/**
 * Certificate model is based on third party Credly badge
 */
export class Certificate {
  constructor(
    public image: string,
    public title: string,
    public level: string,
    public expires: string,
    public url: string,
    public expiredFlag?: boolean, // This is UI custom field and non Credly field
    public expiryDueDate?: number // This is UI custom field and non Credly field
  ) {}
}
